import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { ConfigService } from '../../config/config.service';

@Injectable()
export class Ng1LoadedGuard implements CanActivate {
  constructor(private configService: ConfigService) {}
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<boolean> | boolean {
    return this.configService.getValue('BootstrapService').isBootstrapCompeted();
  }
}
